import React, { Fragment } from 'react';
import hlf from './hfl.jpg';
import './estilosComponente.css';
import './mediaqueriesComponente.css';

const Hobbies =()=>{

    const[index,setIndex]=React.useState(-1);
    const[indexDos,setIndexDos]=React.useState(-1);
    const[indexTres ,setIndexTres]=React.useState(-1);
    const[indexCuatro, setIndexCuatro]=React.useState('');
    const[indexCinco,setIndexCinco]=React.useState(0);
    const[indexSeis,setIndexSeis]=React.useState('');
    

    /*Eventos para la ventana modal # 1*/
    const handleClick =(event)=>{
        event.preventDefault();
        setIndex(index + 1);

        const mostrarLectura = document.getElementById("modal");
        mostrarLectura.style.display="flex";
    };

    const handleClose =(event)=>{
        event.preventDefault();

        const cerrar = document.getElementById("modal");
        cerrar.style.display="none";
    };

    /*Eventos para la ventana modal # 2*/
    const handleClickDos =(event)=>{
        event.preventDefault();
        setIndexDos(indexDos + 1);

        const mostrarPelicula = document.getElementById("modalDos");
        mostrarPelicula.style.display="flex";
    };

    const handleCloseDos =(event)=>{
        event.preventDefault();

        const cerrarDos = document.getElementById("modalDos");
        cerrarDos.style.display="none";
    };

    /*Eventos para la ventana modal # 3*/
    const handleClickTres =(event)=>{
        event.preventDefault();
        setIndexTres(indexTres + 1);

        const mostrarCancion = document.getElementById("modalTres");
        mostrarCancion.style.display="flex";
    };

    const handleCloseTresUno =(event)=>{
        event.preventDefault();

        const cerrarTres = document.getElementById("modalTres");
        cerrarTres.style.display="none";

        const stopMusic = document.getElementById("videoPlay");
        stopMusic.src = 'null';

    };

    const handleCloseTresDos =(event)=>{
        event.preventDefault();

        const cerrarTres = document.getElementById("modalTres");
        cerrarTres.style.display="none";
    };

    /*Eventos para la ventana modal # 4*/
    const handleClickCuatro =(event)=>{
        event.preventDefault();
        setIndexCuatro(app);

        const mostrarApp = document.getElementById("modalCuatro");
        mostrarApp.style.display="flex";
    };

    const handleCloseCuatro =(event)=>{
        event.preventDefault();

        const cerrarCuatro = document.getElementById("modalCuatro");
        cerrarCuatro.style.display="none";
    };

    /*Eventos para la ventana modal # 5*/
    const handleClickCinco =(event)=>{
        event.preventDefault();
        setIndexCinco(indexCinco + 1);

        const mostrarTipDeporte = document.getElementById("modalCinco");
        mostrarTipDeporte.style.display="flex";
    };

    const handleCloseCinco =(event)=>{
        event.preventDefault();

        const cerrarCinco = document.getElementById("modalCinco");
        cerrarCinco.style.display="none";
    };

    /*Eventos para la ventana modal # 6*/
    const handleClickSeis =(event)=>{
        event.preventDefault();
        setIndexSeis(juegos);

        const mostrarJuego = document.getElementById("modalSeis");
        mostrarJuego.style.display="flex";
    };

    const handleCloseSeis =(event)=>{
        event.preventDefault();

        const cerrarSeis = document.getElementById("modalSeis");
        cerrarSeis.style.display="none";
    };

    /*Evento de botones*/

    const handleCambiar =(event)=>{
        event.preventDefault();

        const ocultarHobbie = document.getElementById("bloque-uno");
        ocultarHobbie.style.display="none";

        const mostrarHobbie = document.getElementById("bloque-dos");
        mostrarHobbie.style.display="flex";

        const botonStyle = document.getElementById("btn-dos");
        botonStyle.style.border="2px solid #fff";

        const botonStyleDos = document.getElementById("btn-uno");
        botonStyleDos.style.border="none";

    };

    const handleCambiarDos =(event)=>{
        event.preventDefault();

        const ocultarHobbieDos = document.getElementById("bloque-dos");
        ocultarHobbieDos.style.display="none";

        const mostrarHobbieDos = document.getElementById("bloque-uno");
        mostrarHobbieDos.style.display="flex";

        const botonStyle = document.getElementById("btn-uno");
        botonStyle.style.border="2px solid #fff";

        const botonStyleDos = document.getElementById("btn-dos");
        botonStyleDos.style.border="none";
    };

    let lecturaList = [
        'The Chronicles of Narnia',
        'The Alchemist',
        'Señor Presidente',
        'The Book Thief',
        "The Power of God's Names",
        'The Man Who Counted',
        'Veronika decides to Die',
        'Hombres de Maíz',
        'Mathematics...¿are you there?',
        'Mathematics for Iñaki'
    ];

    let peliculaList = [
        'Slumdog Millionare',
        'Gravity',
        'Hidden Figures',
        'The Green Mile',
        'Interstellar',
        'The Terminal',
        "Schindler's list",
        'Amelie',
        'V for Vendetta',
        'The Martian'
    ];

    let deportesList = [
        'Do not forget to walk 1 hour every day',
        'Exercising has benefits for your skin',
        'Exercise helps you against insomnia',
        'Music + exercise = Cool',
        'Exercise helps fight depression',
        'Exercise helps generate new neurons',
        'Exercise = healthy heart',
        'Exercise = good mood',
        'Prevents brain wear',
        'Exercise is therapeutic'
    ];

    let app = 'In the near future I will study React Native to create mobile applications';

    let juegos = 'Half life';

    let playList =[
        <iframe 
        id="videoPlay" 
        width="90%" 
        src="https://www.youtube.com/embed/aBKEt3MhNMM" 
        title="Starman" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen></iframe>,

        <iframe 
        id="videoPlay" 
        width="90%" 
        src="https://www.youtube.com/embed/UuOL3kV2mEs" 
        title="Line" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen></iframe>,

        <iframe 
        id="videoPlay" 
        width="90%" 
        src="https://www.youtube.com/embed/-xKM3mGt2pE" 
        title="Take on me" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen></iframe>,

        <iframe 
        id="videoPlay" 
        width="90%" 
        src="https://www.youtube.com/embed/0J2QdDbelmY" 
        title="Seven Nation Army" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen></iframe>,

        <iframe 
        id="videoPlay" 
        width="90%" 
        src="https://www.youtube.com/embed/m7EPuB7fv6M" 
        title="Broken Youth" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen></iframe>
    ];

    return(
        <Fragment>
            <div className='bloque-principal'>

                {/*Modal # 1: Reading*/}
                <div 
                className='modal' 
                id="modal">
                    <div className='titulo-modal'>
                        <p>Reading</p>
                    </div>
                    <div className='mensaje-recomendacion'>
                        {
                            index <= 9
                            ? 'My recommendation for today is:'
                            : <i 
                            className="fab fa-readme" 
                            id="estilo-especial"></i>
                        }
                    </div>
                    <div className='mensaje-modal'>
                        {
                            index >= 10
                            ? 'Wait for more recommendations'
                            : lecturaList[index]
                        }
                    </div>
                    <button className='boton-modal' onClick={handleClose}>Close</button>
                </div>

                {/*Modal # 2: Movies*/}
                <div 
                className='modalDos' 
                id="modalDos">
                    <div className='titulo-modalDos'>
                        <p>Movies</p>
                    </div>
                    <div className='mensaje-recomendacionDos'>
                        {
                            indexDos <= 9
                            ? 'My recommendation for today is:'
                            : <i 
                            className="fas fa-ticket-alt"
                            id="estilo-especial"></i>
                        }
                    </div>
                    <div className='mensaje-modalDos'>
                        {
                            indexDos >= 10
                            ? 'Wait for more recommendations'
                            : peliculaList[indexDos]
                        }
                    </div>
                    <button className='boton-modalDos' onClick={handleCloseDos}>Close</button>
                </div>

                {/*Modal # 3: Music*/}
                <div 
                className='modalTres' 
                id="modalTres">
                    <div className='titulo-modalTres'>
                        <p>Music</p>
                    </div>
                    <div className='mensaje-recomendacionTres'>
                        {
                            indexTres < 5
                            ? 'My recommendation for today is:'
                            : <i 
                            className="fas fa-compact-disc" 
                            id="estilo-especial"></i>
                        }
                    </div>
                    <div className='mensaje-modalTres'>
                        {
                            indexTres >= 5
                            ? 'Wait for more recommendations'
                            : playList[indexTres]
                        }
                    </div>
                    <button className='boton-modalTres' onClick=
                    {
                        indexTres >= 5
                        ? handleCloseTresDos
                        : handleCloseTresUno
                    }>Close</button>
                </div>

                {/*Modal # 4: Mobile apps development*/}
                <div 
                className='modalCuatro' 
                id="modalCuatro">
                    <div className='titulo-modalCuatro'>
                        <p>Apps</p>
                    </div>
                    <div className='mensaje-modalCuatro'>{indexCuatro}</div>
                    <button className='boton-modalCuatro' onClick={handleCloseCuatro}>Close</button>
                </div>

                {/*Modal # 5: Sports*/}
                <div 
                className='modalCinco' 
                id="modalCinco">
                    <div className='titulo-modalCinco'>
                        <p>Sports</p>
                    </div>
                    <div className='mensaje-recomendacionCinco'>
                        {
                            indexCinco <= 9
                            ? 'The tip of the day:'
                            : <i 
                            className="fas fa-futbol estilo-especial" 
                            id="estilo-especial"></i>
                        }
                    </div>
                    <div className='mensaje-modalCinco'>
                        {
                            indexCinco >= 10
                            ? 'Wait for more recommendations'
                            : deportesList[indexCinco]
                        }
                    </div>
                    <button className='boton-modalCinco' onClick={handleCloseCinco}>Close</button>
                </div>

                {/*Modal # 6: Games*/}
                <div 
                className='modalSeis' 
                id="modalSeis">
                    <div className='titulo-modalSeis'>
                        <p>Games</p>
                    </div>
                    <img src={hlf} className='imagen-juego' alt="Half Life log"/>
                    <div className='mensaje-modalSeis'>{indexSeis}</div>
                    <button className='boton-modalSeis' onClick={handleCloseSeis}>Close</button>
                </div>

                {/*-----------------------------------------------------------------------*/}

                <div 
                className='bloque-uno' 
                id="bloque-uno">
                    <div 
                    className='subloque-uno' 
                    onClick={handleClick}>
                        <div className='icono-pasatiempo'>
                            <i className="fab fa-readme"></i>
                        </div>
                        <div className='texto-pasatiempo'>Reading</div>
                    </div>
                    <div 
                    className='subloque-uno' 
                    onClick={handleClickDos}>
                        <div className='icono-pasatiempo'>
                            <i className="fas fa-ticket-alt"></i>
                        </div>
                        <div className='texto-pasatiempo'>Movies</div>
                    </div>
                    <div 
                    className='subloque-uno' 
                    onClick={handleClickTres}>
                        <div className='icono-pasatiempo'>
                            <i className="fas fa-compact-disc"></i>
                        </div>
                        <div className='texto-pasatiempo'>Music</div>
                    </div>
                </div>

                <div 
                className='bloque-dos' 
                id="bloque-dos">
                    <div 
                    className='subloque-dos' 
                    onClick={handleClickCuatro}>
                        <div className='icono-pasatiempo'>
                            <i className="fas fa-mobile-alt"></i>
                        </div>
                        <div className='texto-pasatiempo'>Apps</div>
                    </div>
                    <div 
                    className='subloque-dos' 
                    onClick={handleClickCinco}>
                        <div className='icono-pasatiempo'>
                            <i className="fas fa-futbol"></i>
                        </div>
                        <div className='texto-pasatiempo'>Sports</div>
                    </div>
                    <div 
                    className='subloque-dos' 
                    onClick={handleClickSeis}>
                        <div className='icono-pasatiempo'>
                            <i className="fas fa-gamepad"></i>
                        </div>
                        <div className='texto-pasatiempo'>Games</div>
                    </div>
                </div>
                
                <div className='contenedor-boton-pasatiempo'>
                    <button 
                    className='boton-pasatiempo btn-inicial' 
                    id="btn-uno" 
                    onClick={handleCambiarDos}>
                        <i className="fas fa-caret-left"></i>
                    </button>

                    <button 
                    className='boton-pasatiempo' 
                    id="btn-dos" 
                    onClick={handleCambiar}>
                        <i className="fas fa-caret-right"></i>
                    </button>
                </div>

            </div>

        </Fragment>

    );
};

export default Hobbies;